import type { Window } from "./scheduleTree";
import { KEY_DATE_NAMES, type KeyDateRef } from "src/modules/engagement/components/phases/emailSms/emailSmsTypes";

export type PlacedKeyDate = { label: string; leftPct: number; when: Date };

/** Key dates that fall inside the chart window, placed as a percentage across it. */
export function placeKeyDates(keyDates: KeyDateRef[], window: Window): PlacedKeyDate[] {
  return keyDates
    .map((keyDate) => {
      if (!keyDate.date) return null;
      const when = new Date(keyDate.date);
      if (isNaN(when.getTime())) return null;
      if (when < window.start || when > window.end) return null;
      const offset = (when.getTime() - window.start.getTime()) / 86400000;
      return {
        label: keyDate.label?.trim() || KEY_DATE_NAMES[keyDate.type] || keyDate.type,
        leftPct: (offset / window.totalDays) * 100,
        when,
      };
    })
    .filter((k): k is PlacedKeyDate => k !== null);
}

/*
    A dashed line down the whole chart per key date. Every email and SMS trigger is an offset
    from one of these, so a touch's position is only readable against the date it hangs off.
*/
export function KeyDateLines({ keyDates }: { keyDates: PlacedKeyDate[] }) {
  return (
    <>
      {keyDates.map((keyDate) => (
        <span
          key={`${keyDate.label}-${keyDate.leftPct}`}
          className="sched-track__keydate"
          style={{ left: `${keyDate.leftPct}%` }}
          title={`${keyDate.label} · ${keyDate.when.toLocaleDateString(undefined, {
            month: "short",
            day: "numeric",
            year: "numeric",
          })}`}
        />
      ))}
    </>
  );
}

export default KeyDateLines;
